var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-content-bookmark",
    },
    [
      _c("courseware-content-bookmarks"),
      _vm._v(" "),
      _c(
        "MountingPortal",
        {
          attrs: {
            mountTo: "#courseware-content-bookmark-filter-widget",
            name: "sidebar-views",
          },
        },
        [_c("courseware-content-bookmark-filter-widget")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }